// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3ucXd","content":"RecentSearches_content__2-zyi"};